import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress harmless AbortError from HTMLMediaElement.play() interruptions
// (occurs when video/audio elements unmount or are paused while play() is pending).
window.addEventListener("unhandledrejection", (event) => {
  const err = event.reason;
  if (err && (err.name === "AbortError" || /The operation was aborted/.test(err.message || ""))) {
    event.preventDefault();
  }
});
window.addEventListener("error", (event) => {
  const err = event.error || event.message;
  const msg = (err && err.message) || (typeof err === "string" ? err : "");
  if (/AbortError/.test(msg) || /The operation was aborted/.test(msg)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
// Build: 1774015749
